var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResilinc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 181,
    viewBox: "0 0 104 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1201 180.301L55.6201 132.521H48.6201L52.1201 180.301Z",
    fill: "#1154A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1201 0.410156L48.6201 48.1902H55.6201L52.1201 0.410156Z",
    fill: "#1154A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8697 54.3799L58.5196 63.7299L85.1497 90.3599L58.5196 116.99L67.8697 126.34L103.85 90.3599L67.8697 54.3799ZM36.3696 54.3799L0.389648 90.3599L36.3696 126.34L45.7197 116.99L19.0896 90.3599L45.7197 63.7299L36.3696 54.3799Z",
    fill: "#4CBF92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResilinc);
export default __webpack_public_path__ + "static/media/Resilinc.5ede24805d3372715d9b0e6376672f68.svg";
export { ForwardRef as ReactComponent };